import * as React from "react";

import { ModuleRegistryProvider } from "@com.mgmtp.a12.client/client-core/lib/core/application";
import { FrameFactories } from "@com.mgmtp.a12.client/client-core/lib/core/frame";
import { View } from "@com.mgmtp.a12.client/client-core/lib/core/view";
import { CRUDViews } from "@com.mgmtp.a12.crud/crud-core";
import { TreeEngineFactories } from "@com.mgmtp.a12.treeengine/treeengine-core/lib/extensions/client";

export function createViewProvider(state: object): View.Provider {
	function chainedViewProvider(componentName: string): React.ComponentType<View> {
		return (
			crudViewProvider(componentName) ||
			FrameFactories.viewProvider(componentName) ||
			TreeEngineFactories.viewComponentProvider(componentName) ||
			Placeholder
		);
	}

	return ModuleRegistryProvider.getViewProvider(state, chainedViewProvider);
}

/**
 * Create View provider for Overview and Form engine.
 */

const components: { [name: string]: React.ComponentType<View> | undefined } = {
	FormCRUD(props) {
		return <CRUDViews.FormEngineView {...props} />;
	},
	OverviewCRUD(props) {
		return <CRUDViews.OverviewEngineView {...props} />;
	}
};

function crudViewProvider(name: string): React.ComponentType<View> | undefined {
	return components[name];
}

function Placeholder(props: View) {
	return <div>No view renderer found: `{props.name}`</div>;
}
